<template>

    <b-card
            :title="getTitle"
            :img-src="picUrl"
            img-alt="Image"
            img-top
            tag="article"
            class="mb-2 shadow p-3 mb-5 rounded-lg card cursor">
        <b-row style="padding-left: 15px">
            <div :key="item.name" v-for="item in getTags">
                <b-button v-bind:style="{ backgroundColor: item.color}">{{item.name}}</b-button>
            </div>
        </b-row>
        <b-row>
            <b-col cols="4">
                <b-card-text class="info">
                    verzija: {{getVersion}}
                </b-card-text>
            </b-col>
            <b-col cols="8" align="right">
                <b-card-text class="info">
                    Datum objave: {{getPublishedDate}}
                </b-card-text>
            </b-col>
            <b-col cols="12" align="right">
                <b-card-text class="info">
                    TRL: {{getTrl}}
                </b-card-text>
            </b-col>
        </b-row>
        <hr>
        <b-card-text>
            <span v-html="getDescription"></span>
        </b-card-text>
    </b-card>
</template>

<script>
    import {pmisColorsMixin} from "../../../mixins/pmis-colors-mixin";
    // import {presentation} from "../../presentation/presentation";
    import presentation from "./../../data/presentation";

    export default {
        name: "SolutionCard",
        props: ["name"],
        mixins: [pmisColorsMixin],
        computed: {
            picUrl() {
                return "./pic/resitve/primeri/" + this.name + ".jpg";
            },
            getTitle() {
                return presentation.resitve.solutions[this.name].title;
            },
            getDescription() {
                return presentation.resitve.solutions[this.name].description;
            },
            getVersion() {
                return presentation.resitve.solutions[this.name].version.toString();
            },
            getPublishedDate() {
                return presentation.resitve.solutions[this.name].publishedDate.toString();
            },
            getTrl() {
                return presentation.resitve.solutions[this.name].trl;
            },
            getTags() {
                return presentation.resitve.solutions[this.name].tags;
            }
        },
        methods: {
            openDemo() {
                this.$modal.show("single-element-modal-dialog", presentation[this.name]);
            }
        }
    }
</script>

<style lang="scss" scoped>

    .card-body {
        padding-left: 0px;
        padding-right: 0px;
    }

    .cursor {
        cursor: pointer;
    }

    .solution-title {
        font-size: 1.4em;
        text-align: center;
        margin-top: 10px;
        color: white;
    }

    p {
        color: #6F6F6F;
        font-size: 0.85em;
    }

    .info {
        font-size: 0.8em;
    }

    .solution-logo {
        margin: 4vh 2vw;
    }

    .solution-button {
        margin-bottom: 15px;
        color: white;
        font-size: 1.5em;
    }

    h4 {
        color: #68C2CD;
    }

    .solution-header {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }

    #solution-picture {
        max-height: 56px;
    }

    button {
        border: none;
        padding: 1px 5px 1px 5px;
        margin: 0px 5px 5px 0px;
    }

    article:hover {
        h4 {
            font-weight: bold;
        }
    }

</style>
